/*
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-09-07 16:16:40
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2021-12-21 15:01:35
 */


export default {
	"route.dashboard": "Dashboard",
	"route.robot": "Robot",
	"route.robotList": "Robot list",
	"route.groupManage": "Group management",
	"route.disinfect": "Task",
	"route.home": "Home",
	"route.disinfectTask": "Task",
	"route.building": "Building",
	"route.accessControl": "Access control",
	"route.ladderControl": "Elevator control",
	"route.IOT": "IOT",
	"route.accounts": "Account",
	"route.roles": "Role",
	"route.jurisdiction": "Permission",
	"route.dispatcher": "Task dispatcher",
	"navbar.logOut": "Log out",
	"login.title": "Enterprise ID login",
	"login.logIn": "Log in",
	"login.username": "Username",
	"login.tip_username": "Please enter the username",
	"login.password": "Password",
	"login.company_id": "Enterprise ID",
	"login.tip_company": "Please enter the enterprise ID",
	"login.tip_pwd": "Please enter the password",
	"robot.projectTtitle": "Robot management platform",
	"robot.manage": "Robot management",
	"system.search": "Search",
	"system.reset": "Reset",
	"system.open": "Unfold",
	"system.retract": "Fold",
	"system.status": "Status",
	"system.inProgress": "In progress",
	"system.normalCompletion": "Completed",
	"system.abnormalEnd": "Abnormal end",
	"system.noData": "No data",
	"universality.confirm": "Confirm",
	"universality.cancel": "Cancel",
	"universality.Pleasedonot": "Please do not enter blank",
	"universality.Pleaseifsymbols": "Please enter 6-20 digits, English or special symbols",
	"disinfect.robotremarkname": "Robot remark",
	"disinfect.EnterNoteName": "Enter a remark ",
	"disinfect.robotSerialNumber": "Robot serial number",
	"disinfect.inputSequenceNumber": "Input a serial number",
	"disinfect.selectStatus": "Select status",
	"disinfect.destination": "Destination",
	"disinfect.Enterdestination": "Input a destination",
	"disinfect.dates": "Date",
	"disinfect.tos": "To",
	"disinfect.startDates": "Start date",
	"disinfect.endDates": "End date",
	"disinfect.starttimes": "Start time",
	"disinfect.endtimes": "End time",
	"disinfect.Lastweek": "Last week",
	"disinfect.Lastmonth": "Last month",
	"disinfect.Lastthreemonths": "Last 3 months",
	"disinfect.nonExecution": "Not executed",
	"disinfect.canceled": "Cancel",
	"disinfect.UnclaimedProperty": "Not picked up",
	"disinfect.hardwareFailure": "Hardware failure",
	"disinfect.NavigationFault": "Navigation failure",
	"disinfect.Manualcancellation": "Manual cancellation",
	"navigationBar.logout": "Log out",
	"navigationBar.logoutandsystem": "Log out the account and system?",
	"account.userlist": "User list",
	"account.searchnames": "Search by account or name",
	"account.adduser": "Add a user",
	"account.user": "User",
	"account.roles": "Role",
	"account.ResponsibleRobot": "Robot in charge",
	"account.name": "Name",
	"account.remark": "Remark",
	"account.Recentloginiof": "Last login info",
	"account.operation": "Operation",
	"account.compile": "Edit",
	"account.resetpasswords": "Reset the password",
	"account.delete": "Delete",
	"account.pleaseuserpasnumb": "6-20 English letters, numbers, special characters",
	"account.pleasepasswordnumb": "6-20 English letters, numbers,  special characters",
	"account.selectroles": "Select the role",
	"account.selectbuild": "Select the building",
	"account.inputnames": "Please input the user name",
	"account.inputremarks": "Please input remarks",
	"account.userdetail": "User details",
	"account.platform": "Unit",
	"account.noBindingRobot": "No available robot",
	"account.addtimes": "Added time",
	"account.LastonlineTime": "Last login time",
	"account.Resetsuccessfully": "Reset successfully",
	"account.initialPassword": "Original password",
	"account.gotIt": "Got it",
	"account.PleaseRoles": "Please select the role",
	"account.Pleasebuilds": "Please select the building",
	"account.PleaseRobots": "Please select the robot",
	"account.compileusers": "Edit the account",
	"account.deleteusers": "Delete the account",
	"account.Unabletologinafterdeleting": "Unable to log in after deleting the account, please confirm",
	"account.alreadyexistsConfirmpasswords": "Reset the password to the original password?",
	"account.alreadyExists": "The account already exists",
	"map.deleteThecloudmap": "To delete the cloud map will simultaneously delete the map from all associated robots. Are you sure?",
	"map.deletemaps": "Delete the map",
	"homes.robotTotal": "Total number of robots (units)",
	"homes.tasksTotal": "Total number of accumulative tasks",
	"homes.onlineTimeTotal": "Accumulative online time",
	"homes.nearly-7-days-onlineTime": "The trend of online time in the last 7 days",
	"homes.cumulativeMileage": "Accumulative mileage(meter)",
	"homes.robotWorkingHoursData": "The data of robot working hours",
	"homes.trendWorkingHours": "Trend of working hours",
	"homes.explain": "Notes",
	"homes.explainContent": "Delivery data of the robot in different buildings",
	"homes.to": "To",
	"homes.startTime": "Start time ",
	"homes.endTime": "End time",
	"homes.proportionWorkingHours": "Proportion of working hours",
	"homes.buildingDeliveryList": "Ranking list of delivery times in the building",
	"public.second": "times",
	"public.rice": "m",
	"public.lastSevenDays": "Last 7 days",
	"public.lastFourteenDays": "Last 14 days",
	"public.lastThirtyDays": "Last 30 days",
	"robotState.notActive": "Not activated",
	"robotState.abnormalEnd": "Abnormal end",
	"robotState.hasLeft": "Left",
	"robotState.online": "Online",
	"robotState.offline": "Offline",
	"robotState.charge": "Charge",
	"robotState.unknown": "Unknown",
	"robotState.atWork": "At work",
	"robotState.free": "Free",
	"robotState.unexecuted": "Not executed",
	"robotState.executing": "In progress",
	"robotState.canceled": "Cancelled",
	"robotState.Completed": "Completed",
	"robotState.nobodyTakesThings": "Not picked up",
	"robot.robotList": "Robot list",
	"robot.buildings": "Building",
	"robot.selectBuilding": "Select the building",
	"robot.search": "Search by remark or serial number",
	"robot.notAddRobot": "No robot added or activated",
	"robot.mileage": "Total mileage",
	"robot.information": "Basic information",
	"robot.noteName": "Remark",
	"robot.model": "Model",
	"robot.onlineStatus": "Online status",
	"robot.workingStatus": "Working status",
	"robot.currentPower": "Current power",
	"robot.serialNumber": "Serial number",
	"robot.operationData": "Operation data",
	"robot.latestOnlineTime": "Last online time",
	"robot.cumulativeOnlineDuration": "Cumulative online time",
	"robot.cumulativeDeliveryTimes": "Cumulative times of delivery",
	"robot.cumulative-delivery-time": "Cumulative delivery time",
	"robot.cumulativeLeadTimes": "Cumulative times of escorting",
	"robot.cumulativeLeadTime": "Cumulative escorting time",
	"robot.System-Hardware": "System and hardware",
	"robot.systemVersion": "System version",
	"robot.hardwareStatus": "Hardware status",
	"robot.language": "System language",
	"robot.voice_pack": "Voice pack",
	"robot.box_model": "Cabinet",
	"robot.android_soft": "Android software",
	"robot.android_mirror": "Android ROM",
	"robot.header_control": "Head control board",
	"robot.under_panel_version": "Chassis version",
	"robot.under_mirror": "Chassis ROM",
	"robot.under_master": "Chassis master control",
	"robot.under_control": "Chassis control board",
	"robot.rgbd_up": "RGBD(top)",
	"robot.rgbd_down": "RGBD(bottom)",
	"robot.doorControlMotor": "Door control motor",
	"robot.frontMountedCamera": "Front camera",
	"robot.overheadCamera": "Top camera",
	"robot.infraredDetectionBox": "Infrared detection ",
	"robot.microphone": "Microphone",
	"robot.radar": "Lidar",
	"robot.head-RGBD": "Head RGBD",
	"robot.bottom-RGBD": "Bottom RGBD",
	"robot.ultrasonicSensor": "Ultrasonic sensor",
	"robot.IMU": "IMU",
	"robot.hubMotor": "Hub motor",
	"robot.emergencyStopSwitch": "Emergency stop button",
	"robot.horn": "Speaker",
	"robot.getFailed": "Failed to get",
	"robot.normal": "Normal",
	"robot.abnormal": "Abnormal",
	"robot.cancel": "Cancel",
	"robot.confirm": "Confirm",
	"public.noteNameCannotBeEmpty": "The remark can not be empty",
	"public.layer": "Floor",
	"public.door": "Building",
	"public.rename": "Rename",
	"public.delete": "Delete",
	"robot.percentageTasksCompletedTotal": "Percentage of cumulative tasks completed",
	"robotState.workSuspension": "Task suspended",
	"buiding.buildingList": "Building list",
	"buiding.add": "Add",
	"buiding.addFloors": "Add a floor",
	"buiding.pleaseCompleteBuidingsData": "Please complete the building data in the list on the left!",
	"buiding.map": "Map",
	"buiding.source": "Source",
	"buiding.uploadTime": "Upload time",
	"buiding.pleaseRobotUploadMap": "Please upload the map to the robot",
	"buiding.associatedBuildings": "Associated buildings",
	"buiding.robot": "Robot",
	"buiding.associatedRobot": "Associated robots",
	"buiding.associatedShop": "Associated stores",
	"buiding.type": "Type:",
	"buiding.pleaseType": "Please select the type",
	"buiding.buildingName": "Building name",
	"buiding.pleaseBuildingName": "Please input the building name",
	"buiding.shopName": "Store name",
	"buiding.pleaseShopName": "Please input the store name",
	"buiding.floor": "Floor:",
	"buiding.floorName": "Floor name:",
	"buiding.pleaseFloorName": "Floor name:",
	"buiding.floorNameBeEmpty": "Floor name can not be empty",
	"buiding.buid": "Building",
	"buiding.shop": "Store",
	"buiding.serialNumberCannotBeEmpty": "Serial number can not be empty",
	"buiding.buildingAdd": "Add a building",
	"buiding.pleaseBuilsdingName": "Please input the building name",
	"buiding.buildingsNameBeEmpty": "Building name can not be empty",
	"buiding.AreYouSureToDeleteThisFloor": "Are you sure you want to delete the \"floor\"?",
	"buiding.deleteFloor": "Delete the floor",
	"buiding.AreYouSureToDeleteThisShop": "Are you sure you want to delete the \"store\"?",
	"buiding.deleteShop": "Delete the store",
	"buiding.AreYouSureToDeleteThisBuilding": "Are you sure you want to delete the \"building\"?",
	"buiding.deleteBuilding": "Delete the building",
	"buiding.editBuilding": "Edit the building ",
	"buiding.editFloor": "Edit the floor",
	"buiding.editShop": "Edit the store",
	"buiding.shopNameAlreadyExists": "Store name already exists",
	"buiding.shopAddSuccess": "Store added successfully",
	"buiding.floorNameAlreadyExists": "Floor name already exists",
	"buiding.floorAddSuccess": "Floor added successfully",
	"buiding.buildingNameAlreadyExists": "Building name already exists",
	"buiding.buildingAddSuccess": "Building added successfully",
	"buiding.shopEditSuccess": "Store edited successfully",
	"buiding.buildingEditSuccess": "Building edited successfully",
	"buiding.floorEditSuccess": "Floor edited successfully",
	"buiding.selectRobot": "Select a robot",
	"buiding.replacementBuildings": "Change to another building",
	"role.rolelist": "Role list",
	"role.addroles": "Add a role",
	"role.names": "Name",
	"role.Entername": "Input a name",
	"role.PleaseEntername": "Please input a name",
	"role.editroles": "Edit the role",
	"role.deleteroles": "Delete the role",
	"role.Confirmdeletion": "Are you sure you want to delete the \"role\"? You can't undo this action.",
	"role.nameAlreadyExists": "The role name already exits",
	"navigationBar.personalInfo": "Personal information",
	"navigationBar.changePassword": "Change password",
	"navigationBar.administrator": "Administrator",
	"navigationBar.domesticConsumer": "General user",
	"navigationBar.originalPsd": "Original password",
	"navigationBar.EnterOriginalPsd": "Input the original password",
	"navigationBar.newPassword": "New password",
	"navigationBar.confirmPassword": "Confirm the password",
	"navigationBar.EntertheNewPsdAga": "Enter the new password again",
	"navigationBar.TheOriPsdCannotEmpty": "Original password can not be empty",
	"navigationBar.TheNewPsdempty": "New password can not be empty",
	"navigationBar.PleEntertheNewPsdAga": "Please input the new password again",
	"navigationBar.TheNewPasastheoldone": "The new password is the same as the old password",
	"navigationBar.Psdisinconsistentwith": "The two passwords are different. Please confirm.",
	"navigationBar.modifySuccessfully": "Modified successfully",
	"accessControl.accessControlList": "Access control list",
	"accessControl.floor": "Floor",
	"accessControl.accessControlAdd": "Add an access control ",
	"accessControl.accessControlID": "Access control ID",
	"accessControl.selectAccessControlID": "Select the access control ID",
	"accessControl.accessControlID-Hint": "Access control service is confirmed. The customer has already configured the access control ID.",
	"accessControl.label": "Remark",
	"accessControl.pleaseLabel": "Input the remark",
	"accessControl.deleteAccessControl-Hint": "To delete the access control will make the robot unable to perform cross-automatic door tasks. Are you sure?",
	"accessControl.deleteAccessControl": "Delete the access control",
	"accessControl.editAccessControl": "Edit the access control",
	"accessControl.accessControlIdExists": "Access control ID already exists",
	"public.notAssociatedFloor": "Not associated with the floor",
	"public.notAssociatedBuilding": "Not associated with the building",
	"public.all": "All",
	"public.rules.pleaseLabel": "Please input the remark",
	"dispatcher.dispatcherList": "Task dispatcher list",
	"dispatcher.searchName": "Search by name",
	"buiding.deleteShopTips": "Please unlink all data (robots/maps) of the shop firstly",
	"buiding.deleteBuidingTips": "Please unlink all data (robots/maps) of the building firstly",
	"buiding.deleteFloorTips": "Please unlink all data (maps) of the floor firstly",
	"ladderControl.ladderControlList": "Elevator control list",
	"ladderControl.addLadderControl": "Add an elevator control",
	"ladderControl.grouping": "Grouping",
	"ladderControl.Buildings": "Building",
	"ladderControl.You-can-go-to-the-floor": "Accessible floors",
	"ladderControl.pleaseGoToBuilding": "Please go to the building and link the elevator control",
	"ladderControl.grouping-tips-1": "Grouping is mainly used to distinguish different elevator call points",
	"ladderControl.grouping-tips-2": "1. For the situation of only one elevator or multiple elevators on the same floor, you can select the default group",
	"ladderControl.grouping-tips-3": "2. Elevators on different floors and waiting halls need to be divided into groups",
	"public.common": "Building",
	"ladderControl.ladderControlID": "Elevator control ID",
	"ladderControl.selectLadderControlID": "Select elevator control ID",
	"ladderControl.ladderControlID-tips": "Please check with the elevator control/access control service that the customer has already configured the elevator control ID",
	"ladderControl.groupingPlaceholder": "Enter or select a group (eg: high-rise elevators)",
	"ladderControl.deleteladderControl": "Delete elevator control",
	"ladderControl.deleteladderControl-tips": "To delete the elevator control will make the robot unable to perform cross-floor tasks. Are you sure?",
	"ladderControl.ladderControlIdExists": "The elevator control ID already exists",
	"login.remTheNub": "Remember the password",
	"login.oldPasswordError": "Original password error",
	"login.confirmAndNewParrword": "The two passwords are not the same",
	"robot.advertising": "Advertisements",
	"homes.buildingDeliveryTimes": "Delivery times",
	"robot.detail": "Robot details",
	"robot.robotModel": "Robot type",
	"robot.header_control-2": "Android power board",
	"robot.under_mirror-2": "Chassis ROM",
	"robot.under_master-2": "Chassis master control",
	"robot.under_control-2": "Chassis power board",
	"robot.nav": "Navigation algorithm",
	"robot.up_rgbd": "Top RGBD",
	"robot.down_rgbd": "Bottom RGBD",
	"robot.camera": "Top camera",
	"robot.ss": "Front camera",
	"robot.rgbd_top_depth": "Top RGBD-depth",
	"robot.rgbd_top_color": "Top RGBD-color",
	"robot.rgbd_bottom_depth": "Bottom RGBD-depth",
	"robot.rgbd_bottom_color": "Bottom RGBD-color",
	"robot.ultrasonic1": "Left ultrasound",
	"robot.ultrasonic2": "Right ultrasound",
	"robot.motor1": "Left hub motor",
	"robot.motor2": "Right hub motor",
	"robot.detection": "Object detection",
	"buiding.builNameAlreadyExists": "Building name already exists",
	"robot.bindingSuccess": "Bound successfully",
	"robot.notActive": "Inactivated",
	"robotinfo.logdown": "Log download",
	"robotinfo.Logtype": "Log type",
	"robotinfo.displayboard": "Display board",
	"robotinfo.maincontrolpanel": "Main control board",
	"robotinfo.powerstrip": "Power board",
	"robotinfo.navigationdata": "Navigation data",
	"robotinfo.Plethedate": "Please select a date",
	"robotinfo.Plethetime": "Please select a time",
	"robotinfo.acquire": "Download",
	"robotinfo.Packinglog": "Packing logs",
	"robotinfo.Uploadinglogfiles": "Uploading log file",
	"robotinfo.Gettinguploadstatus": "Getting upload status",
	"robotinfo.acquiresuccess": "Successfully acquired",
	"robotinfo.clicktodownload": "Click to download",
	"robotinfo.Plelogtype": "Please select a log type",
	"robotinfo.Plestartdateandtime": "Please select a start date and time",
	"robotinfo.Pleanenddateandtime": "Please select an end date and time",
	"robotinfo.Nologtime": "No log for this time period",
	"robotinfo.logtaskispackagedpackged": "The robot is currently packing or uploading logs",
	"robotinfo.failtoget": "Failed to get",
	"robotinfo.Failedtopackage1/2": "Failed to pack 1/2",
	"robotinfo.Failedtopackage2/2": "Failed to pack 2/2",
	"robotinfo.failtoupload": "Upload failed",
	"public.unrelatedBuildings": "Unassociated with building",
	"buiding.sameFloorNumber": "The same floor number already exists in this building",
	"navigationBar.pleaseEnterOriginalPsd": "Please enter the original password",
	"navigationBar.newpassword": "Enter a new password (please enter 6-20 digits, English, symbols)",
	"navigationBar.pleaseNewpassword": "Please enter a new password",
	"login.nnterprise-number-error": "Enterprise ID error",
	"home.Fullrobot": "All robots",
	"map.displaytext": "Display text",
	"map.nonetext": "Do not display text",
	"robot.detection-1": "Item Detection 1",
	"robot.detection-2": "Item Detection 2",
	"robot.detection-3": "Item Detection 3",
	"robot.detection-4": "Item Detection 4",
	"robot.current_systemVersion": "Current version",
	"robot.cumulativeTimes": "Cumulative times of delivery",
	"robot.cumulativeTime": "Cumulative delivery time",
	"home.hour": "h",
	"home.min": "min",
	"home.deliverytimes": "Delivery times (times)",
	"login.actpaswdinco": "Incorrect username or password",
	"login.enterpriseerror": "Enterprise ID error",
	"home.numberofworkmachs": "Number of working robots",
	"home.workinghours": "Working hours",
	"login.account_expired": "Account has expired. Please log in again",
	"robot.CADEBOT_rankingList_tips": "Ranking of delivery times at destination",
	"robot.setLabel": "Successfully set the remark",
	"homes.nearly-7-days-mileage": "Mileage trend in the last 7 days",
	"robot.robotisofflineobtalogs": "Logs are unavailable as the robot is offline",
	"buiding.buid-illustrate": "Building (for multiple storeys)",
	"buiding.shop-illustrate": "Store (for single storey)",
	"buiding.new-pleaseFloorName": "Please enter the floor name",
	"route.admage": "Advertisements",
	"route.asset": "Resource library",
	"route.ads": "Ad Release",
	"route.adsDetail": "Ad Details",
	"route.addAds": "Add Ad",
	"route.editAds": "Edit Ads",
	"ad.asset": "Resource List",
	"ad.freeSpace": "Space left",
	"ad.uploadAsset": "Upload resources",
	"ad.filename": "File name",
	"ad.type": "Type",
	"ad.memory": "Memory",
	"ad.video": "Video",
	"ad.image": "Image",
	"ad.uploadTime": "Upload time",
	"ad.uploadProgress": "Upload progress",
	"ad.uploadSuccess": "Upload successful",
	"ad.operation": "Operation",
	"ad.check": "View",
	"ad.delete": "Delete",
	"ad.confirm": "Confirm",
	"ad.cancel": "Cancel",
	"ad.deleteSuccess": "Deleted successfully",
	"ad.back": "Return",
	"ad.deleteAsset": "Deleting resources",
	"ad.deleteAssetWarningMessage": "Deleted resources will not be recovered, confirm deletion?",
	"ad.extLimit": "Only files in JPG, PNG, MP4, AVI, MOV, WMV, RMVB formats can be uploaded.",
	"ad.sizeLimit": "A single file cannot exceed 1GB",
	"ad.syncFail": "Download failed",
	"ad.syncComplete": "Download completed",
	"ad.downloadComplete": "Configuration in progress",
	"ad.downloadWaiting": "Not downloaded",
	"ad.name": "Name",
	"ad.playTime": "Displaying time",
	"ad.materialNum": "Number of resources",
	"ad.robotNum": "Number of cast robots",
	"ad.startTime": "Publish time",
	"ad.addSchema": "Add ad",
	"ad.copySchema": "Copy Plan",
	"ad.edit": "Edit",
	"ad.publish": "Publish",
	"ad.deleteDraft": "Delete Plan",
	"ad.save": "Save",
	"ad.preview": "Preview",
	"ad.setDefault": "Use Now",
	"ad.setDefaultPlease": "Please set if default",
	"ad.yes": "Yes",
	"ad.no": "No",
	"ad.deleteDraftWarningMessage": "Confirm deletion of the plan?",
	"ad.draft": "Not Published",
	"ad.schemaDetail": "Plan Details",
	"ad.schemaContent": "Plan Content",
	"ad.syncRecord": "Synchronized recording",
	"ad.robotSn": "Dropping robots",
	"ad.robotSelect": "Select robot",
	"ad.nameInput": "Enter the plan name",
	"ad.robotSelectPlease": "Please select robot",
	"ad.nameInputPlease": "Please enter a plan name",
	"ad.materialList": "Resource List",
	"ad.materialListDescriptions": "Advertising screen dimension: 1080*1920. Drag the material frame to adjust the order.",
	"ad.setting": "Advertising settings",
	"ad.period": "Time period",
	"ad.allDay": "All day",
	"ad.someTime": "Time period",
	"ad.beginTime": "Start time",
	"ad.endTime": "End time",
	"ad.materialLib": "Resource library",
	"ad.materialNumber": "Number of resources",
	"ad.removeScreen": "Delete split screen",
	"ad.removeScreenConfirm": "Confirm to delete split screen?",
	"ad.playTimeDuration": "Playback duration",
	"ad.picturePlayTime": "Image playing duration",
	"ad.addPeriod": "Add time slot",
	"ad.addPeriodLimit": "You can add 6 different time slots",
	"ad.totalTime": "Total duration",
	"ad.saveSuccess": "Save successfully",
	"ad.publishSuccess": "Publish successfully",
	"ad.addPeriodFail": "Already have a full day time slot, can not be added",
	"ad.publishFail": "Publish failed",
	"ad.playTimeNoEmpty": "Play time cannot be empty",
	"ad.materialListNoEmpty": "Split screen can not be left empty",
	"ad.robot": "Robot",
	"ad.robotOffline": "Robot offline",
	"ad.robotOfflineAndCanNotLaunch": "The following robots are offline and cannot be placed",
	"ad.robotUplineOrSaveDraft": "Please operate the robot online, or save the plan as a draft first.",
	"ad.syncStatus": "Robot Download Status",
	"ad.reSync": "Republish",
	"ad.goBackList": "Back to list",
	"ad.confirmPublish": "Are you sure you want to publish?",
	"ad.robotOfflineToConfirmPublish": "The following robot is offline, can you confirm the publish?",
	"ad.addCancelConfirm": "Do you want to confirm that the current content is not saved after returning?",
	"ad.refresh": "Refresh",
	"ad.publishTime": "Publish time",
	"ad.lastModifyTime": "Last modified time",
	"ad.publisher": "Published by",
	"ad.editor": "Modified by",
	"ad.timeOverlap": "Playback periods cannot overlap, please check",
	"ad.endTimeMustLargerThanStartTime": "The end time of the playback period must be greater than the start time",
	"ad.cannotDeleteAssetUsed": "This clip has been referenced and cannot be deleted.",
	"ad.deletePeriodWarningMessage": "Do you want to confirm the deletion of time slots?",
	"ad.complete": "Done",
	"ad.fail": "Failed",
	"ad.nameInputIllegal": "Plan name cannot contain special characters",
	"ad.nameDuplicate": "The plan name already exists",
	"ad.updateTime": "Latest modification time",
	"role.TherolesDeletingfails": "The role is bound to an account, deletion failed",
	"account.Changeofauthority": "Permission change",
	"account.ThepermisschgePleaseagain": "The permission of this account has been changed",
	"disinfect.Unknowncause": "No known reason",
	"robot.accumulatedTaskExecutionTimes": "Cumulative number of tasks performed",
	"home.minute": "minutes",
	"homes.Statisticstasks": "Statistics of the performing tasks (in progress)",
	"disinfect.Initilizati": "Initialization failed",
	"disinfect.Failedtogetlocation": "Failed to get location",
	"disinfect.pointisoffthemap": "The target point is outside the map",
	"disinfect.onastaticobstacle": "The target point is on a static obstacle",
	"disinfect.therearenoroadsonthestaticmap": "No path on static map",
	"disinfect.Startingpointobstacle": "Obstacle at the starting point",
	"disinfect.Lossoflocation": "Lost location",
	"disinfect.Failedtolocatethelostlocalpath": "Partial path planning failed",
	"disinfect.Clifftriggercancellation": "Cliff triggers the task cancellation",
	"disinfect.Emergencystoptriggerscancellation": "Emergency stop trigger cancelled",
	"disinfect.Collisionbartriggercancel": "Anti-collision strip trigger cancelled",
	"disinfect.overtime": "Time out",
	"disinfect.Chargingpiledetectionfailed": "Charging dock detection failed",
	"disinfect.Pilefailure": "Failed to pile up",
	"disinfect.GlobalpathplanningfailedProcedure": "Overall path planning failed",
	"disinfect.Slopetriggercancellation": "Slope trigger cancelled",
	"disinfect.NavigationrecoverybeProcedure": "Navigation recovery failed",
	"disinfect.Navigateoutnarrowchannel": "Narrow path is blocked",
	"disinfect.Androidtasktimeout": "Task timeout",
	"disinfect.elsesa": "other errors",
	"robot.historicaldelete": "This robot's historical data will be deleted, confirm deletion?",
	"robot.delfaild": "Deletion failed",
	"robot.LoRa_ID": "LoRa ID",
	"robot.associatedSIMCard": "Associated SIM card",
	"robot.accumulatedUsageTraffic": "Cumulative traffic usage",
	"robot.trafficUsageMonth": "Monthly traffic usage",
	"robot.newrgbd_bottom_depth": "Bottom RGBD-depth",
	"robot.batteryTest": "Battery Detection",
	"robot.Partial_information_update_failed": "Some information update failed",
	"robot.update_failed": "Update failed",
	"robot.update_robot_datasSuccess": "Get the latest data of the robot successfully",
	"ad.waitForDownload": "waiting to download",
	"ad.startDownload": "start download",
	"ad.offLineAndCannotDownload": "Device offline, unable to download",
	"ad.syncing": "synchronizing...",
	"robot.robot_does_not_exist": "robot does not exist",
	"robot.robot_current_enterprise": "Robots have left the current enterprise",
	"ad.notEnoughSpace": "There is not enough space for enterprise materials, please clean up the files in time",
	"ad.addAsset": "add material",
	"robot.batteryCommunication": "battery communication",
	"disinfect.Thetargetpointisobstacle": "Target point is on a dynamic obstacle",
	"disinfect.Therearenoroadsonadynamicmap": "No roads on the dynamic map",
	"robot.buildingRobotErrorTips_10019": "The number of robots in this store has reached the upper limit of 16, please change the building (store)",
	"robot.buildingRobotErrorTips_10020": "Error generating LoraId",
	"map.VirtualWall": "Virtual wall",
	"map.tracks": "Track",
	"map.Qrcode": "QR code",
	"map.regions": "Area",
	"map.anchorpoints": "Position point",
	"robot.noSearchResults": "no search results",
	"robot.accountInformationHasBeenModified": "Account information has been modified",
	"public.tips": "tips",
	"public.agreeWith": "agree",
	"public.iHaveReadAndAgree": "I have read and agree",
	"public.userAgreement": "User Agreement",
	"public.gentle": "and",
	"public.privacyAgreement": "Privacy Policy",
	"public.pleaseAgreeFirst": "please agree first",
}